<p class="text-danger">
  @if (form?.submitted && control.errors) {
    @if (control.errors?.['required']) {
      <span tmwTranslate="entity.field.required">Required</span>
    } @else if (control.errors?.['pattern']) {
        <span tmwTranslate="entity.field.pattern">Pattern</span>
    } @else if (control.errors){
      <span tmwTranslate="entity.field.invalid">Pattern</span>
    }
  }
</p>
